<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <img src="{{img}}" alt="">
        </div>
    </div>
</div>